import React from 'react';
import { Flex } from "./Container"
import { Text } from "./Text"

export const AmtDecimalSubscript = (props) => {
    return (
        <Flex bottom>
            <Text size={props.size || '24px'} weight={props.weight || 600} height='32px'>{props.amt.split('.')[0]}</Text>
            <Text size={props.subscriptSize || '14px'} weight={props.subscriptWeight || 400} style={{ paddingBottom: props.paddingBottom || '2px' }}>.{props.amt.split('.')[1]}</Text>
        </Flex>
    )
}